<template>
    <div style="height:100%;">
        <div class="toolbar" style="width:170px">
            <h5 style="color:white;margin-left:16px;margin-top:0.5em;margin-bottom:-0.1em">{{msg}}</h5>
            <el-slider class="slide"
                    :min="0"
                    :max="1"
                    :step="0.01"
                    v-model="valueAlpha"
                    show-input>
            </el-slider>
        </div>
        <div id="csContainer"></div>
    </div>
</template>

<script>
    import util from "../../components/util"

    export default {
        data() {
            return {
                msg:'模型透明度',
                vw: null,
                entity: null,
                valueAlpha: 1
            }
        },
        watch: {
            valueAlpha: function (val) {
                this.valueAlphaChanged(val);
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                let vw = util.getViewer("csContainer");
                this.vw = vw;
                this._createModel();
            },
            valueAlphaChanged(valAlpha) {
                let entity = this.entity;
                let color = Cesium.Color.WHITE;
                let newColor = Cesium.Color.fromAlpha(color, parseFloat(valAlpha));
                entity.model.color = newColor;
            },
            _createModel() {
                let viewer = this.vw;
                let url = "/demo/static/data/models/people.glb";
                let height = 0;
                viewer.entities.removeAll();

                let position = Cesium.Cartesian3.fromDegrees(-123.0744619, 44.0503706, height);
                let heading = Cesium.Math.toRadians(135);
                let pitch = 0;
                let roll = 0;
                let hpr = new Cesium.HeadingPitchRoll(heading, pitch, roll);
                let orientation = Cesium.Transforms.headingPitchRollQuaternion(position, hpr);

                let entity = viewer.entities.add({
                    name: url,
                    position: position,
                    orientation: orientation,
                    model: {
                        uri: url,
                        minimumPixelSize: 128,
                        maximumScale: 20000,
                        scale:0.01
                    }
                });
                this.entity = entity;
                viewer.trackedEntity = entity;
            }
        }
    }
</script>

<style lang="stylus" scoped>
    #csContainer 
        height: 100%;
    .toolbar
        margin-top:30px;
        height:110px;
        background-color:rgba(0, 0, 0, 0.5);
    .el-slider
        display: flex;
        flex-direction: column;
    .slide >>>.el-slider__input
        position: absolute;
        margin-top: 43px;
        width: 130px;
   .el-slider>>>.el-slider__runway.show-input 
        margin-right: 160px;
        width: 125px;
    .el-slider>>>.el-slider__runway
        margin:16px;
    .slide>>>.el-slider__input {
        position: absolute;
        margin: 40px 16px 0px 16px;
        width: 130px;
}
</style>
